var _a, _b;
const enableTestId = typeof process !== 'undefined' && ((_a = process.env) === null || _a === void 0 ? void 0 : _a.ENVIRONMENT) !== 'prod' && ((_b = process.env) === null || _b === void 0 ? void 0 : _b.ENVIRONMENT) !== 'production';

export { enableTestId };
